(function(){
"use strict";
var scheduled=false;
var payCache={slug:null,data:null,at:0};
var PROJECT_URL="https://ycentdpkspjdrzijrbsl.supabase.co";
var API_KEY="sb_publishable_TgKotXn3vvPpdnad_wXc9g_X1DY7arT";

function isPublicSale(){
  var h=location.hash||"";
  return h.indexOf("#/s/")===0 || h==="#/example-sales-page";
}
function currentSlug(){
  var h=location.hash||"";
  if(h.indexOf("#/s/")!==0)return null;
  var rest=h.slice(4).split("?")[0].split("/")[0];
  try{return decodeURIComponent(rest);}catch(e){return rest;}
}
function esc(s){
  return String(s==null?"":s)
    .replace(/&/g,"&amp;").replace(/</g,"&lt;")
    .replace(/>/g,"&gt;").replace(/"/g,"&quot;")
    .replace(/'/g,"&#039;");
}
async function getPaymentMethods(){
  var slug=currentSlug();
  if(!slug)return null;
  if(payCache.slug===slug&&payCache.data&&Date.now()-payCache.at<60000)return payCache.data;
  var r=await fetch(PROJECT_URL+"/rest/v1/rpc/get_public_group_payment_methods_v1",{
    method:"POST",
    headers:{"apikey":API_KEY,"Content-Type":"application/json"},
    body:JSON.stringify({p_campaign_slug:slug})
  });
  if(!r.ok)return null;
  var data=await r.json();
  payCache={slug:slug,data:data,at:Date.now()};
  return data;
}

function sellerInfo(){
  var el=document.createElement("section");
  el.id="customer-delivery-info";
  el.className="customer-delivery-note";
  el.innerHTML=
    '<div class="customer-delivery-note-inner">'+
      '<div class="customer-delivery-note-icon" aria-hidden="true">📦</div>'+
      '<div>'+
        '<h3>Så fungerar beställning och leverans</h3>'+
        '<p><strong>Du beställer av gruppen.</strong> Din beställning samlas tillsammans med gruppens övriga beställningar. Gruppen bestämmer själv när försäljningen avslutas. Därefter har gruppen upp till <strong>14 dagar</strong> att betala sin samlade beställning till Kampansera. När betalningen är registrerad skickas varorna till gruppen för utdelning.</p>'+
      '</div>'+
    '</div>';
  return el;
}
function checkoutInfo(){
  var el=document.createElement("div");
  el.className="customer-delivery-note compact js-customer-delivery-checkout";
  el.innerHTML=
    '<div class="customer-delivery-note-inner">'+
      '<div class="customer-delivery-note-icon" aria-hidden="true">ℹ️</div>'+
      '<div>'+
        '<h3>Viktigt om leveransen</h3>'+
        '<p>Det här är en gruppbeställning. Leverans sker först efter att gruppen har avslutat sin försäljningsperiod och betalat sin samlade beställning till Kampansera. Gruppen har då upp till <strong>14 dagar</strong> på sig att betala.</p>'+
      '</div>'+
    '</div>';
  return el;
}
function confirmationInfo(){
  var el=document.createElement("div");
  el.className="customer-delivery-note confirmation js-customer-delivery-confirmation";
  el.innerHTML=
    '<div class="customer-delivery-note-inner">'+
      '<div class="customer-delivery-note-icon" aria-hidden="true">✓</div>'+
      '<div>'+
        '<h3>Vad händer nu?</h3>'+
        '<p>Din beställning är registrerad hos gruppen. Gruppen fortsätter sin försäljning tills de själva avslutar kampanjen. Därefter betalar gruppen sin samlade beställning till Kampansera inom 14 dagar och varorna skickas till gruppen för utdelning.</p>'+
      '</div>'+
    '</div>';
  return el;
}
function paymentBox(data){
  if(!data||(data.swish_enabled!==true&&data.cash_enabled!==true))return null;
  var el=document.createElement("div");
  el.className="customer-payment-methods js-customer-payment-methods";
  var html='<h3>Betala din beställning</h3><p>Betala beloppet som visas i din beställning direkt till gruppen.</p>';

  if(data.swish_enabled===true&&data.swish_number){
    html+='<div class="cpm-row">';
    if(data.swish_qr_url)html+='<img class="cpm-qr" src="'+esc(data.swish_qr_url)+'" alt="Swish QR-kod">';
    html+='<div class="cpm-details"><div class="cpm-chip">Swish</div>'+
      '<div class="cpm-number">'+esc(data.swish_number)+'</div>'+
      '<div class="cpm-recipient">Mottagare: '+esc(data.swish_recipient_name||data.group_name||"Gruppen")+'</div>'+
      '<p style="margin-top:.45rem">Swisha totalsumman från beställningen. Visa gärna betalningen för säljaren.</p></div></div>';
  }
  if(data.cash_enabled===true){
    html+='<div class="cpm-row"><div class="cpm-details"><div class="cpm-chip">Kontant</div>'+
      '<p>Kontantbetalning är tillåten. Betala totalsumman direkt till säljaren.</p></div></div>';
  }
  el.innerHTML=html;
  return el;
}

function injectSeller(){
  var old=document.getElementById("customer-delivery-info");
  if(!isPublicSale()){if(old)old.remove();return;}
  if(old)return;
  var products=document.querySelector(".sell-products");
  if(products&&products.parentNode){products.parentNode.insertBefore(sellerInfo(),products);return;}
  var banner=document.querySelector(".sell-banner");
  if(banner&&banner.parentNode){
    if(banner.nextSibling)banner.parentNode.insertBefore(sellerInfo(),banner.nextSibling);
    else banner.parentNode.appendChild(sellerInfo());
  }
}
function injectCheckout(){
  document.querySelectorAll(".modal .modal-body").forEach(function(modal){
    var looksLikeCheckout=modal.querySelector(".checkout-product,.checkout-total");
    if(!looksLikeCheckout||modal.querySelector(".js-customer-delivery-checkout"))return;
    var total=modal.querySelector(".checkout-total");
    var info=checkoutInfo();
    if(total&&total.parentNode)total.parentNode.insertBefore(info,total);
    else modal.appendChild(info);
  });
}
async function injectConfirmation(){
  var data=null;
  try{data=await getPaymentMethods();}catch(e){}
  document.querySelectorAll(".success-panel").forEach(function(panel){
    if(!panel.querySelector(".js-customer-delivery-confirmation"))panel.appendChild(confirmationInfo());
    if(!panel.querySelector(".js-customer-payment-methods")){
      var box=paymentBox(data);
      if(box)panel.appendChild(box);
    }
  });
}
function run(){
  scheduled=false;
  injectSeller();
  injectCheckout();
  injectConfirmation();
}
function schedule(){
  if(scheduled)return;
  scheduled=true;
  requestAnimationFrame(run);
}
window.addEventListener("hashchange",function(){payCache={slug:null,data:null,at:0};schedule();});
document.addEventListener("DOMContentLoaded",schedule);
var observer=new MutationObserver(schedule);
observer.observe(document.body,{childList:true,subtree:true});
schedule();
})();